<div class="row">
    <div class="col-12 px-3">
        <mat-card class="simple-card mx-auto mb-5">
            <mat-card-content>
                <div class="row">
                    <div class="col-12 d-flex justify-content-between align-items-center mb-4">
                        <div class="mr-5">
                            <h1>Estado de Servicios</h1>
                            <p class="text-muted mb-0">
                                Monitoree aquí la operatividad de sus servicios. Nuestro sistema utiliza algoritmos inteligentes para actualizar cada estado de forma dinámica, garantizando una visibilidad precisa de acuerdo con el comportamiento y la demanda transaccional de cada proceso.
                            </p>
                        </div>
                        <button mat-fab aria-label="botón con icono de refrescar" class="custom-button-primary" [disabled]="isServiciosLoading" (click)="listServices()">
                            <i class="fa fa-refresh icon-font" aria-hidden="true"></i>
                        </button>
                    </div>

                    <div class="col-12 mb-4">
                        <mat-chip-listbox [formControl]="statusControl">
                            <mat-chip-option [value]="STATUSES.DISPONIBLE" class="available-chip">Disponible</mat-chip-option>
                            <mat-chip-option [value]="STATUSES.INTERMITENTE" class="warning-chip">Intermitente</mat-chip-option>
                            <mat-chip-option [value]="STATUSES.FUERA_SERVICIO" class="error-chip">Fuera de servicio</mat-chip-option>
                        </mat-chip-listbox>
                    </div>

                    <div class="col-12 mb-5">
                        <mat-accordion>
                            <mat-expansion-panel>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <div class="d-flex align-items-center w-100">
                                            <mat-icon class="info-icon mr-2">info</mat-icon>
                                            <h3>¿Qué significa cada estado?</h3>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="d-flex flex-column py-2">

                                    <div class="d-flex align-items-stretch">

                                        <div class="status-item d-flex flex-column align-items-center px-3 py-2">
                                            <mat-chip class="available-chip mb-3">
                                                <mat-icon matChipAvatar>check_circle</mat-icon>
                                                Disponible
                                            </mat-chip>
                                            <small class="text-muted">
                                                Indica que el servicio se encuentra disponible según la última actualización.
                                            </small>
                                        </div>

                                        <div class="border-left"></div>

                                        <div class="status-item d-flex flex-column align-items-center px-3 py-2">
                                            <mat-chip class="warning-chip mb-3">
                                                <mat-icon matChipAvatar>error</mat-icon>
                                                Intermitente
                                            </mat-chip>
                                            <small class="text-muted">
                                                Indica que el servicio está con problemas y está presentando intermitencia desde la última actualización indicada.
                                            </small>
                                        </div>

                                        <div class="border-left"></div>

                                        <div class="status-item d-flex flex-column align-items-center px-3 py-2">
                                            <mat-chip class="error-chip mb-3">
                                                <mat-icon matChipAvatar>cancel</mat-icon>
                                                Fuera de servicio
                                            </mat-chip>
                                            <small class="text-muted">
                                                Indica que el servicio no se encuentra disponible.
                                            </small>
                                        </div>

                                    </div>

                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>

                    </div>

                    <div class="col-12">

                        <mat-card class="px-3 rounded-card" appearance="outlined">
                            <mat-card-header>
                                <mat-card-title>Servicios</mat-card-title>
                            </mat-card-header>
                            <mat-card-content>
                                <ng-container *ngIf="!isServiciosLoading; else serviciosIsLoading">
                                    <div *ngIf="filteredServicios.length; else emptyState" class="grid-container my-3">
                                        <mat-card *ngFor="let servicio of filteredServicios" class="service-card" (click)="openServiceDialog(servicio)">
                                            <mat-card-content class="h-100 d-flex flex-column justify-content-between">
                                                <mat-card-title>{{ servicio.nombre }}</mat-card-title>
                                                <mat-chip [ngClass]="getChipColorClass(servicio.estado)">
                                                    <mat-icon matChipAvatar>
                                                        {{ getStatusIcon(servicio.estado) }}
                                                    </mat-icon>
                                                    {{ servicio.estado }}
                                                </mat-chip>
                                            </mat-card-content>
                                        </mat-card>
                                    </div>

                                    <ng-template #emptyState>
                                        <div class="empty-state d-flex flex-column align-items-center">
                                            <mat-icon class="big-icon">search_off</mat-icon>
                                            <h2>No hay servicios que coincidan con los filtros</h2>
                                        </div>
                                    </ng-template>
                                </ng-container>

                                <ng-template #serviciosIsLoading>
                                    <div class="data-loading">
                                        <mat-spinner diameter="50"></mat-spinner>
                                    </div>
                                </ng-template>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>
